import { Installers, Players } from '../../../shared/api-models/admin';
import { PlayerStatus } from '../../../shared/api-models/delivery';

export class PlayersView extends Players {
	playerStatus?: PlayerStatus;
	installer?: Installers;
	installDateView?: string;
	playersByHostname?: PlayersView[];
	areaCodeAndPhone?: string;
}
